(function () {
  const SNIPPET_SELECTOR = ".okendo-StarRatingSnippet, .okendo-ProductListingSnippet";
  const RENDERED_SELECTOR = ".oke-sr, .oke-stars, .okeReviews";
  const PROCESSED_ATTR = "data-oke-sanitized";
  const OBSERVED_ATTR = "data-oke-observer";

  function parseReviewPayload(el) {
    const script = el.querySelector("script[data-oke-metafield-data], script[type='application/json']");
    if (script) {
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return null;
      }
    }

    const text = (el.textContent || "").trim();
    if (text.charAt(0) !== "{") return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function reviewCountFrom(payload) {
    if (!payload || typeof payload !== "object") return null;
    if (
      payload.reviewCount == null &&
      payload.reviewAverageValue == null &&
      payload.averageRating == null
    ) {
      return null;
    }
    return Number(payload.reviewCount || 0);
  }

  function productIdFrom(el) {
    const item = el.closest(".boost-sd__product-item, [data-product-id]");
    if (!item) return "";
    return item.getAttribute("data-product-id") || "";
  }

  function hideSnippet(el) {
    el.textContent = "";
    el.setAttribute("hidden", "");
    el.style.display = "none";
    el.setAttribute(PROCESSED_ATTR, "");
  }

  function promoteToWidget(el, productId, payload) {
    el.removeAttribute("hidden");
    el.style.removeProperty("display");
    el.setAttribute("data-oke-star-rating", "");
    if (productId) {
      el.setAttribute("data-oke-reviews-product-id", "shopify-" + productId);
    }
    if (payload) {
      el.textContent = JSON.stringify(payload);
    }
    el.setAttribute(PROCESSED_ATTR, "");
  }

  function sanitize(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const snippets = scope.querySelectorAll(SNIPPET_SELECTOR);
    let needsInit = false;

    snippets.forEach(function (el) {
      if (el.getAttribute(PROCESSED_ATTR)) return;

      if (el.querySelector(RENDERED_SELECTOR)) {
        el.removeAttribute("hidden");
        el.style.removeProperty("display");
        el.setAttribute(PROCESSED_ATTR, "");
        return;
      }

      const payload = parseReviewPayload(el);
      const count = reviewCountFrom(payload);
      const productId = productIdFrom(el);

      if (count === 0) {
        hideSnippet(el);
        return;
      }

      if (count > 0) {
        promoteToWidget(el, productId, payload);
        needsInit = true;
        return;
      }

      const text = (el.textContent || "").trim();
      if (!text) hideSnippet(el);
    });

    if (needsInit) initOkendoWidgets();
  }

  let initTimer;
  function initOkendoWidgets() {
    clearTimeout(initTimer);
    initTimer = setTimeout(function () {
      if (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === "function") {
        window.okeWidgetApi.initAllWidgets();
      }
    }, 50);
  }

  let sanitizeTimer;
  function scheduleSanitize(root) {
    clearTimeout(sanitizeTimer);
    sanitizeTimer = setTimeout(function () {
      sanitize(root || document);
    }, 50);
  }

  function observeProductLists() {
    document
      .querySelectorAll(".boost-sd__filter-product-list, .boost-sd__product-list")
      .forEach(function (container) {
        if (container.getAttribute(OBSERVED_ATTR)) return;
        container.setAttribute(OBSERVED_ATTR, "");
        new MutationObserver(function () {
          scheduleSanitize(container);
        }).observe(container, { childList: true, subtree: true });
      });
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    scheduleSanitize(document);
    observeProductLists();

    const start = Date.now();
    const interval = setInterval(function () {
      observeProductLists();
      if (document.querySelector(".boost-sd__product-item")) {
        scheduleSanitize(document);
      }
      if (Date.now() - start > 20000) clearInterval(interval);
    }, 500);
  });

  window.sanitizeOkendoStarRatings = scheduleSanitize;
})();
